export default "__VITE_ASSET__V4wVr4KC__"